module.exports = __webpack_public_path__ + "img/tintuc12.4ab220c7.png";